export enum CatalogOrigin {
  CHAIN = "CHAIN",
  STORE = "STORE",
}
